const styleOverrides = {
  root: {
    '.OriSelectList&>[role="option"]:hover': {
      fontWeight: 'bold',
      backgroundColor: `rgba(0,0,0,.12)`
    },
    '.OriSelectList&>[aria-selected="true"]': {
      position: 'relative',
      fontWeight: 'bold',
      backgroundColor: 'unset'
    },
    '.OriSelectList&>[aria-selected="true"]:before': {
      position: 'absolute',
      left: 0,
      borderRight: '3px solid currentColor',
      borderRadius: '0 2px 2px 0',
      height: '100%',
      content: '""'
    }
  }
};
export default {
  styleOverrides
};